import './input.css';
import re from '../../functions/regx';


export default ({
    textView, // (placeholder)
    pattern,  // for regx
    onChange, // function
    value:props_value, // value
    disable, // disable to write
    language, // for replace charter
    type:typeInput, // type
    name, // name
    autoComplete,
    myStyle,
    style,
    direction}) => {

    const he = ["/", "'", "ק", "ר", "א", "ט", "ו", "ן", "ם", "פ", "ש", "ד", "ג", "כ", "ע", "י", "ח", "ל", "ך", "ף", ",", "ז", "ס", "ב", "ה", "נ", "מ","צ","ת","ץ", "."];
    const en = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', "'", 'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/'];

    function checkInput(e) {
        let value = e.target.value;
        
        if (language) {
            value = value.toLowerCase();
            let letters = {};
            if (language === 'en') {
                for (let i = 0; i < en.length; i ++) {letters[he[i]] = en[i]};
            } else if (language === 'he') {
                for (let i = 0; i < en.length; i ++) {letters[en[i]] = he[i]};
            }
            if (language === 'en' || language === 'he') {
                let ch = value.charAt(value.length - 1);
                if (letters[ch]) {
                    value = value.replace(ch, letters[ch]);
                }  
            }
        }

        if (typeof(onChange) === 'function') {
            onChange(value);
        }
        if (pattern) {
            if ((! re(pattern, value)) && (value.length > 0)){
                e.target.classList.add('red_valid_input');
            } else {
                e.target.classList.remove('red_valid_input');
            }
        }
    }

    return (
    <input 
    name={name}
    placeholder= {textView} 
    type= {typeInput || 'text'} 
    className={myStyle || 'input'} 
    onInput={(e) => {checkInput(e)}} 
    value={props_value || ''} 
    disabled={disable || false}
    autoComplete={autoComplete || null}
    style={{'direction': language === 'en' || direction === 'ltr' ? 'ltr' : 'rtl', ...style}} 
    />
    )
}